import styled from "styled-components";


export const ReceiverArticle= styled.article`
  border-radius: 15px;
  outline: 1px solid black;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  max-width: 200px;
  width: 100%;
  //height: 190px;

  //&:hover {
  //  background: rgba(246, 238, 229, 0.5);
  //}

  @media (max-width: 760px) {
    &:hover {
      background: transparent;
    }

    cursor: none;
  }
`
export const ReceiverImg= styled.img`
  object-fit: cover;
  width: 100%;
  //height: 100%;
  max-width: 150px;
`



export const ReceiverText= styled.p`
  margin: 0 0 2px 0;
  text-align: center;
  padding: 0 2px 0 2px;
`

